import axios from "./AxiosClient";

const url = `/api`;

const ConcurrentSessionService = {
  getSessions: () => {
    return axios.get(`${url}/sessions`);
  },
  killAllSessions: () => {
    return axios.get(`${url}/killall`);
  },
  keepSessionsAlive: () => {
    return axios.get(`${url}/keepalive`);
  },
  killSession: (session) => {
    return axios.post(`${url}/kill`, { session_id: session.id });
  },
};

export default ConcurrentSessionService;
